import { createSelector } from 'reselect';

const selectBlogsDomain = state => state.blogs;

const makeSelectProcessing = () =>
  createSelector(
    selectBlogsDomain,
    substate => substate.processing,
  );

const makeSelectNextPageProcessing = () =>
  createSelector(
    selectBlogsDomain,
    substate => substate.nextPageProcessing,
  );

const makeSelectBlogs = () =>
  createSelector(
    selectBlogsDomain,
    substate => substate.data,
  );

const makeSelectFilters = () =>
  createSelector(
    selectBlogsDomain,
    substate => substate.filters,
  );

export {
  makeSelectProcessing,
  makeSelectNextPageProcessing,
  makeSelectBlogs,
  makeSelectFilters,
};
